import { useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { FormSelect } from "@/components/form/rhf/FormSelect";
import {
  useMCPToolOptions,
  useReferenceOptionsWithCurrent,
} from "../use-agentic-reference-options";

interface MCPToolSelectProps {
  name: string;
  label: string;
  required?: boolean;
}

export function MCPToolSelect({ name, label, required }: MCPToolSelectProps) {
  const t = useTranslations("workflows");
  const currentValue = useWatch({ name }) as string | undefined;
  const { options, isLoading } = useMCPToolOptions();
  const safeOptions = useReferenceOptionsWithCurrent(options, currentValue);

  return (
    <FormSelect
      name={name}
      label={label}
      options={safeOptions}
      placeholder={
        isLoading
          ? t("drawer.placeholder.loading_tools")
          : t("drawer.placeholder.select_tool")
      }
      disabled={isLoading || safeOptions.length === 0}
      required={required}
    />
  );
}
